<template>
	<div>
		<div class="mianPage">
			<div class="topSearch">
				<el-form class="el-form flex_start">
					<el-form-item>
						<el-select v-model="queryData.companyName" filterable clearable size="small"
							placeholder="公司名称" @change="companySelectChange">
							<el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.label">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.os" clearable size="small" placeholder="操作系统">
							<el-option v-for="item in osOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<!-- <el-select v-model="queryData.id" filterable clearable size="small" style="width:210px" placeholder="APP名称/ID">
							<el-option v-for="item in mediaAppOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select> -->
						<el-select v-model="appSelectForm" clearable @change="appSeleteChange" size="small" value-key="value"
							popper-class="appNameIdOptions" :popper-append-to-body="false" filterable placeholder="请选择应用"
							:remote-method="appRemoteMethod" :loading="appRemoteLoading" remote @clear="getMediaAppOption()">
							<el-option v-for="item in mediaAppOptions" :key="item.value"
								:value="item" :label="`应用：${item.label} | ${item.value}`">
								<!-- :label="`应用：${item.label} | ${item.value}`" -->
								<div class="selectTemp2">
									<div class="selectAppName">{{item.label}}</div>
									<div class=""></div>
									<div class="selectAppId flex_start">
										<div>{{item.value}}</div>
										<img @click.stop="copyName(item.value)" src="../../assets/icon/copy.png" alt="" />
									</div>
								</div>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.platformId" filterable clearable size="small" style="width:210px" placeholder="广告网络">
							<el-option v-for="item in platformOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.checkStatus" clearable size="small" style="width:210px" placeholder="应用状态">
							<el-option label="待审核" :value="1"></el-option>
							<el-option label="运行中" :value="2"></el-option>
							<el-option label="已驳回" :value="3"></el-option>
							<el-option label="已停止" :value="4"></el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item>
						<el-select v-model="queryData.status" clearable size="small" style="width:210px" placeholder="启用状态">
							<el-option label="启用" :value="1"></el-option>
							<el-option label="停用" :value="0"></el-option>
						</el-select>
					</el-form-item> -->
					<div class="menu-right">
						<el-button @click="searchReset" size="small" v-hasPermi="['aggregation:applicationManage:query']">重置</el-button>
						<el-button type="primary" @click="confirmQuery" size="small"
							v-hasPermi="['aggregation:applicationManage:query']">查询</el-button>
					</div>
				</el-form>
			</div>
			<!-- table表格 -->
			<div class="tableBox">
				<el-button type="primary" size="small" @click="addTableData" style="margin-bottom: 16px;"
				v-hasPermi="['aggregation:applicationManage:add']"><i class="el-icon-plus"></i> 新增</el-button>
				<el-table :max-height="560" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="tableData"
					class="el_table">
					<el-table-column prop="companyName" label="公司名称" width="200">
						<template slot-scope="scope">
							<!-- <el-tooltip :content="scope.row.companyName" effect="light">
								<span class="">{{scope.row.companyName}}</span>
							</el-tooltip> -->
							<el-popover placement="top" trigger="hover">
								<div class="popoverName">{{scope.row.companyName}}</div>
								<span class="" slot="reference">{{scope.row.companyName}}</span>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column prop="os" label="操作系统"></el-table-column>
					<!-- <el-table-column prop="id" label="APP ID">
						<template slot-scope="scope">
							<div @click="adSpaceManage(scope.row,scope.$index)">{{scope.row.id}}</div>
						</template>
					</el-table-column> -->
					<el-table-column prop="name" label="APP名称/ID">
						<template slot-scope="scope">
							<div class="appNames flex_start">
								<!-- @click="editTable(scope.row,scope.$index)" -->
								<div @click="adSpaceManage(scope.row,scope.$index)">{{scope.row.name}}</div>
								<img @click="copyName(scope.row.name)" src="../../assets/icon/copy.png" alt="" />
							</div>
							<div style="color: #666666;">{{scope.row.id}}</div>
							<!-- @click="adSpaceManage(scope.row,scope.$index)" -->
						</template>
					</el-table-column>
					<el-table-column label="应用状态" width="140">
						<template slot-scope="scope">
							<div>
								<div class="auditStatus" v-if="scope.row.checkStatus == 1">
									<div class="statusLabel"></div>
									<div>待审核</div>
								</div>
								<div  v-else-if="scope.row.checkStatus == 2">
									<div class="auditStatus" v-if="scope.row.status == 1">
										<div class="statusLabel" style="background: #19B21E;"></div>
										<div>运行中</div>
									</div>
									<div class="auditStatus" v-else-if="scope.row.status == 0">
										<div class="statusLabel" style="background: #AAAAAA;"></div>
										<div style="color: #AAAAAA;">已停止</div>
									</div>
								</div>
								<div v-else-if="scope.row.checkStatus == 3">
									<el-popover placement="top" width="200" trigger="hover" class="el_popover" style="margin-left: auto;">
										<div class="popoverTitle">驳回原因：</div>
										<div>{{scope.row.authFailCause}}</div>
										<div class="auditStatus" slot="reference">
											<div class="statusLabel" style="background: #FC474C;"></div>
											<div>已驳回</div>
										</div>
									</el-popover>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="packageN" label="包名" width="200">
						<template slot-scope="scope">
							<!-- <el-tooltip :content="scope.row.packageN">
								<div class="ellipsis_2">{{scope.row.packageN}}</div>
							</el-tooltip> -->
							<el-popover placement="top" trigger="hover">
								<div class="popoverName">{{scope.row.packageN}}</div>
								<span class="" slot="reference">{{scope.row.packageN}}</span>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column prop="platformName" label="广告网络" width="200">
						<template slot-scope="scope">
							<!-- <el-tooltip :content="scope.row.platformName">
								<div class="ellipsis_2">{{scope.row.platformName}}</div>
							</el-tooltip> -->
							<el-popover placement="top" trigger="hover">
								<div class="popoverName">{{scope.row.platformName}}</div>
								<span class="" slot="reference">{{scope.row.platformName}}</span>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column prop="checkType" label="素材审核方式" width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.checkType==1">通投</div>
							<div v-if="scope.row.checkType==2">先审后投</div>
							<div v-if="scope.row.checkType==3">先投后审</div>
						</template>
					</el-table-column>
					<el-table-column prop="status" label="启用状态" align="center" fixed="right">
						<template slot-scope="scope">
							<el-switch :value="scope.row.status" :disabled="scope.row.checkStatus == 1||scope.row.checkStatus == 3" @input="appSwitchChange($event,scope.row)" :active-value="1"
								:inactive-value="0"></el-switch>
						</template>
					</el-table-column>
					<!-- <el-table-column prop="appKey" label="appKey"></el-table-column>
					<el-table-column prop="budgetConfig" label="预算类型" width="200">
						<template slot-scope="scope">
							<el-tooltip :content="scope.row.budgetConfig">
								<div class="ellipsis_2">{{scope.row.budgetConfig}}</div>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column prop="online" label="是否上架">
						<template slot-scope="scope">
							<div v-if="scope.row.online==1">上架</div>
							<div v-if="scope.row.online==0">未上架</div>
						</template>
					</el-table-column>
					<el-table-column prop="nfySwitch" label="回调方">
						<template slot-scope="scope">
							<div v-if="scope.row.nfySwitch==2">系统回调</div>
							<div v-else>渠道回调</div>
						</template>
					</el-table-column>
					<el-table-column prop="notifyUrl" label="回调地址" width="200">
						<template slot-scope="scope">
							<el-tooltip :content="scope.row.notifyUrl">
								<div class="ellipsis_2">{{scope.row.notifyUrl}}</div>
							</el-tooltip>
						</template>
					</el-table-column> -->
					<!-- <el-table-column prop="notifySecret" label="回调secret" width="200"></el-table-column> -->
					
					<el-table-column prop="" label="操作" fixed="right" width="150">
						<template slot-scope="scope">
							<!-- <el-button type="text" @click="editTable(scope.row,scope.$index)">编辑</el-button> -->
							<!-- <el-dropdown v-hasPermi="['mediaManage:mediaManage:approve']">
								<div class="editBtn flex_center">
									<div class="editBtnTxt">审批</div>
									<i class="el-icon-arrow-down el-icon--right"></i>
								</div>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item>
										<div @click="review(scope.row,scope.$index,2)">通过</div>
									</el-dropdown-item>
									<el-dropdown-item>
										<div @click="review(scope.row,scope.$index,3)">驳回</div>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<el-dropdown v-hasPermi="['mediaManage:mediaManage:more']">
								<div class="editBtn flex_center">
									<div class="editBtnTxt">更多</div>
									<i class="el-icon-arrow-down el-icon--right"></i>
								</div>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item>
										<div @click="editTable(scope.row,scope.$index)">编辑</div>
									</el-dropdown-item>
									<el-dropdown-item>
										<div @click="deleteTable(scope.row,scope.$index)">删除</div>
									</el-dropdown-item>
									<el-dropdown-item>
										<div v-if="scope.row.checkStatus==4" @click="appSwitchChange(2,scope.row)">启用</div>
										<div v-if="scope.row.checkStatus==2" @click="appSwitchChange(4,scope.row)">停用</div>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown> -->
							<div class="tableBtns flex_start">
								<el-button type="text" @click="editTable(scope.row,scope.$index)" v-hasPermi="['aggregation:applicationManage:info']"
								>详情</el-button>
								<div class="splitLineTable"></div>
								<el-button type="text" @click="channelManage(scope.row)" v-hasPermi="['aggregation:applicationManage:association']"
								:disabled="scope.row.status === 0 || scope.row.checkStatus !== 2">网络配置</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
				<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
					<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>

		<el-drawer @close="closeMediaDrawer" :visible.sync="mediaDrawerShow" size="48%" :wrapperClosable="false"
			:with-header="false">
			<!-- <el-dialog title="媒体信息" :visible.sync="dialogVisible" :close-on-click-modal="false"
		  width="28%"> -->
			<el-card class="box-card">
				<div slot="header" class="cardTitle space_between">
					<div class="cardTitleTxt">媒体信息</div>
					<i class="el-icon-circle-close" @click="mediaDrawerShow=false"></i>
				</div>
				<el-form inline class="el-form el_dialog_form" label-width="120px" :rules="mediaRulesApi" :model="mediaFormData"
					ref="ruleMediaForm">
					<el-form-item label="APP名称：" prop="name">
						<el-input clearable size="small" placeholder="请输入" v-model="mediaFormData.name" :disabled="isDisable"></el-input>
					</el-form-item>
					<el-form-item label="公司名称：" prop="companyId">
						<el-select v-model="mediaFormData.companyId" filterable clearable size="small" :disabled="isDisable">
							<el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="OS：" prop="os">
						<el-select v-model="mediaFormData.os" clearable size="small" :disabled="isDisable">
							<el-option v-for="item in osOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="应用市场：" prop="appMarket">
						<!-- <el-input clearable size="small" placeholder="请输入" v-model="mediaFormData.appMarket" :disabled="isDisable"></el-input> -->
						<el-select v-model="mediaFormData.appMarket" clearable size="small" :disabled="isDisable">
							<el-option v-for="item in mediaAppMarketOptions" :key="item.label" :label="item.label" :value="item.label">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="应用详情页：" prop="downLink">
						<el-input clearable size="small" placeholder="请输入" v-model="mediaFormData.downLink" :disabled="isDisable"></el-input>
					</el-form-item>
					<el-form-item label="SHA1值：" prop="sha1" v-if="mediaFormData.os!=='IOS'">
						<el-input clearable size="small" placeholder="请输入" v-model="mediaFormData.sha1" :disabled="isDisable"></el-input>
					</el-form-item>
					<el-form-item label="Bundle ID：" prop="packageN" v-if="mediaFormData.os=='IOS'">
						<el-input clearable size="small" placeholder="请输入" v-model="mediaFormData.packageN" :disabled="isDisable"></el-input>
					</el-form-item>
					<el-form-item label="程序主包名：" prop="packageN" v-else>
						<el-input clearable size="small" placeholder="请输入" v-model="mediaFormData.packageN" :disabled="isDisable"></el-input>
					</el-form-item>
					<el-form-item label="是否网赚">
						<template slot="label">
							<div>是否网赚: 
								<el-tooltip :disabled="tooltipClose" class="item" effect="dark" content="网赚媒体：应用内变现，用户可通过应用内任务赚钱并提现获取收益，常见如IAA工具、游戏类媒体。" placement="top">
									<i class="el-icon-warning-outline tipsIcon"></i>
								</el-tooltip>
							</div>
						</template>
						<el-radio v-model="mediaFormData.isEarn" :label="1" :disabled="isDisable">是</el-radio>
						<el-radio v-model="mediaFormData.isEarn" :label="0" :disabled="isDisable">否</el-radio>
					</el-form-item>
					<el-form-item label="微信开放平台APP ID">
						<template slot="label">
							<div>微信开放平台APP ID:
								<el-tooltip class="item" effect="dark" content="绑定微信App相关信息后可支持跳转微信小程序和小游戏广告; openSDK版本要求 Android端>=5.3.1，i0s端>=1.8.6" placement="top">
									<i class="el-icon-warning-outline tipsIcon"></i>
								</el-tooltip>
							</div>
						</template>
						<el-input v-model="mediaFormData.miniAppId" placeholder="请输入" clearable :disabled="isDisable"></el-input>
					</el-form-item>
					<el-form-item label="合作模式：" prop="type">
						<el-select v-model="mediaFormData.type" clearable size="small" :disabled="isDisable">
							<el-option label="ADN" :value="1"></el-option>
							<el-option label="聚合-黑盒" :value="2"></el-option>
							<el-option label="聚合-回传价格" :value="3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="审核方式：" prop="checkType">
						<el-select v-model="mediaFormData.checkType" clearable size="small" :disabled="isDisable">
							<el-option label="通投" :value="1"></el-option>
							<el-option label="先审后投" :value="2"></el-option>
							<el-option label="先投后审" :value="3"></el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="包名：" prop="packageN">
						<el-input clearable size="small" placeholder="请输入" v-model="mediaFormData.packageN"></el-input>
					</el-form-item> -->
					<!-- <el-form-item label="是否上架：">
						<el-radio v-model="mediaFormData.online" :label="1">是</el-radio>
						<el-radio v-model="mediaFormData.online" :label="0">否</el-radio>
					</el-form-item> -->
					<!-- <el-form-item label="下载地址：">
						<el-input type="textarea" :rows="2" clearable size="small" placeholder="请输入"
							v-model="mediaFormData.downLink"></el-input>
					</el-form-item> -->
					<el-form-item label="回调方：">
						<el-select v-model="mediaFormData.nfySwitch" clearable size="small" :disabled="isDisable">
							<el-option label="渠道回调" :value="1"></el-option>
							<el-option label="系统回调" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="回调地址：">
						<el-input type="textarea" :rows="2" clearable size="small" placeholder="请输入"
							v-model="mediaFormData.notifyUrl" :disabled="isDisable"></el-input>
					</el-form-item>
					<div class="splitLine"></div>
					<el-form-item label="开发者类型：" prop="developerType">
						<el-select :disabled="isDisable" v-model="mediaFormData.developerType" clearable size="small">
							<el-option v-for="item in developerOptions" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
						<div class="formDesc" v-if="mediaFormData.developerType==1">
							如您为应用的实际开发者（<span>平台注册账号是主题与软著主体一致</span>) 请提交《计算机软著著作权登记证书》或《电子版权认证证书》
						</div>
						<div class="formDesc" v-if="mediaFormData.developerType==3">
							如您与应用实际开发者为代理授权关系 （<span>定义:平台注册账号主体与软著主体不一致目存在授权关系</span>）请提交 《计算机软著著作权登记证书》或《电子版权认证证书》及《广告合作授权协议》（请下载 <a href="#" @click="downloadTemp(1)">广告合作授权协议模板</a>并上传）
						</div>
						<div class="formDesc" v-if="mediaFormData.developerType==2">
							如您与应用开发者存在主体关联关系 （定义:<span>平台注册账号主体与软著主体不一致且存在关联关系</span>） 请提交 《计算机软著著作权登记证书》或《电子版权认证证书》及《关联主体关系证明》(请下载 <a href="#" @click="downloadTemp(2)">关联证明模板</a>并上传)
						</div>
					</el-form-item>
					<el-form-item label="应用资质：">
						<template slot="label">
							<div>应用资质:
								<el-tooltip :disabled="tooltipClose" class="item" effect="dark" content="应用的《计算机软著著作权登记证书》或《电子版权证书》" placement="top">
									<i class="el-icon-warning-outline tipsIcon"></i>
								</el-tooltip>
							</div>
						</template>
						<el-upload v-if="!mediaFormData.id||mediaFormData.checkStatus==2||mediaFormData.checkStatus==3" ref='upload' action="#" :auto-upload="true" multiple :before-upload="handleBeforeUpload"
							:on-change="uploadFun" :file-list="fileList" :http-request="uploadSet" :on-remove="handleRemove">
							<div class="uploadBtn">
								<img class="uploadImg" src="../../assets/images/upload.png" alt="" />
								<div class="uploadTxt">点击上传</div>
							</div>
							<div slot="tip" class="el-upload__tip">支持{{ fileType.join("、") }},不超过5MB</div>
						</el-upload>
						<div v-else class="drawTableRowTwo" v-for="item in fileList" >
							<el-tooltip class="item" effect="dark" :content="item.certificationUrl" placement="top">
							  <div class="fileCont" @click="downloadFile(item)">{{item.certificationUrl}}</div>
							</el-tooltip>
						</div>
						<!-- <div class="formDesc">
							（上传文件，支持照片、pdf类型、不超过10MB）
						</div> -->
					</el-form-item>
					<el-form-item label="其他资质：">
						<el-upload v-if="!mediaFormData.id||mediaFormData.checkStatus==2||mediaFormData.checkStatus==3" ref='upload' action="#" :auto-upload="true" multiple :before-upload="handleBeforeUpload"
							:on-change="uploadFunOther" :file-list="fileListOther" :http-request="uploadSetOther" :on-remove="handleRemoveOther">
							<div class="uploadBtn">
								<img class="uploadImg" src="../../assets/images/upload.png" alt="" />
								<div class="uploadTxt">点击上传</div>
							</div>
							<div slot="tip" class="el-upload__tip">支持{{ fileType.join("、") }},不超过5MB</div>
						</el-upload>
						<div v-else class="drawTableRowTwo" v-for="item in fileListOther">
							<el-tooltip class="item" effect="dark" :content="item.certificationUrl" placement="top">
							  <div class="fileCont" @click="downloadFile(item)">{{item.certificationUrl}}</div>
							</el-tooltip>
						</div>
						<!-- <div class="formDesc">
							（上传文件，支持照片、pdf类型、不超过10MB）
						</div> -->
					</el-form-item>
					<el-form-item label="ICP备案：">
						<el-input clearable size="small" placeholder="请输入" :disabled="isDisable" v-model="mediaFormData.icp"></el-input>
					</el-form-item>
					<div class="card-bottom flex_end">
						<el-button @click="closeMediaDrawer" size="medium">取消</el-button>
						<el-button type="primary" @click="confirmMedia('ruleMediaForm')" :disabled="isDisable" size="medium">确定</el-button>
					</div>
				</el-form>
			</el-card>
			<!-- </el-dialog> -->
		</el-drawer>
		<el-dialog title="管理广告网络" :visible.sync="channelDialogVisible" width="28%">
			<el-form inline class="el-form el_dialog_form" label-width="120px" :rules="channelRulesApi"
				:model="channelFormData" ref="ruleChannelForm">
				<el-form-item label="广告网络：" prop="platformId">
					<el-select v-model="networkSelectForm" clearable @change="networkSeleteChange" size="small"
						value-key="id" filterable>
						<el-option v-for="item in networkOptions" :key="item.id" :label="item.label" :value="item">
							<div class="selectTemp flex_start">
								<img :src="item.icon" alt="" />
								<div>{{item.label}}</div>
							</div>
						</el-option>
						<template #prefix>
						  <div class="checkedTemp flex_start" v-if="networkSelectForm.icon">
						  	<img :src="networkSelectForm.icon" alt="" />
						  </div>
						</template>
					</el-select>
				</el-form-item>
				<el-form-item label="账号名称：" prop="platformNetworkId">
					<el-select v-model="channelFormData.platformNetworkId" clearable size="small">
						<el-option v-for="item in accountOptions" :key="item.value" :label="item.label" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="应用ID：" prop="appKey">
					<el-input clearable size="small" placeholder="请输入" v-model="channelFormData.appKey"></el-input>
				</el-form-item>
				<el-form-item label="APP KEY：" prop="appSecret" v-if="hasAppKeySupport">
					<el-input clearable size="small" placeholder="请输入" v-model="channelFormData.appSecret"></el-input>
				</el-form-item>
				<el-form-item label="启用状态：" required>
					<el-switch v-model="channelFormData.status" :active-value="1" :inactive-value="0" style="margin-top: 6px;"></el-switch>
				</el-form-item>
				<div class="card-bottom flex_end">
					<el-button @click="closeChannelDialog" size="medium">取消</el-button>
					<el-button type="primary" @click="confirmChannel('ruleChannelForm')" size="medium">确定</el-button>
				</div>
			</el-form>
		</el-dialog>
		<el-drawer @close="closeDrawer" :visible.sync="companyDrawerShow" size="48%" :wrapperClosable="false"
			:with-header="false">
			<el-card class="box-card">
				<div slot="header" class="cardTitle space_between">
					<div class="cardTitleTxt">网络配置-{{mediaFormData.name}}</div>
					<i class="el-icon-circle-close" @click="companyDrawerShow=false"></i>
				</div>
				<div class="menu-right flex_end">
					<el-button type="primary" @click="addChannel" size="small">新增</el-button>
				</div>
				<el-table :max-height="560" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="channelTableData"
					class="el_table drawerTable">
					<el-table-column prop="" label="广告网络">
						<template slot-scope="scope">
							<div class="selectTemp flex_start" v-if="scope.row.platformName">
								<img :src="scope.row.icon" alt="" />
								<div>{{scope.row.platformName}}</div>
							</div>
							<div v-else> - </div>
						</template>
					</el-table-column>
					<el-table-column prop="account" label="账号名称"></el-table-column>
					<el-table-column prop="appKey" label="应用ID"></el-table-column>
					<el-table-column prop="status" label="启用状态">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.status" @change="channelSwitchChange($event,scope.row)" :active-value="1"
								:inactive-value="0"></el-switch>
						</template>
					</el-table-column>
					<el-table-column prop="" label="操作">
						<template slot-scope="scope">
							<el-button type="text" @click="editChannel(scope.row,scope.$index)">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="card-bottom flex_end">
					<el-button @click="companyDrawerShow=false" size="medium">取消</el-button>
					<el-button type="primary" @click="confirmChannelDrawer()" size="medium">确定</el-button>
				</div>
			</el-card>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				mainHeadTitle: '媒体管理',
				hasPermiDict: 'mediaManage:mediaManage:add',
				companyDrawerShow: false,
				datePicker: [],
				companyOptions: [], // 公司下拉选择列表
				osOptions: this.$api.osOptions, // OS下拉选择列表
				accountOptions: [], // 账号下拉选择列表
				mediaAppOptions: [], // 媒体APP下拉选择列表
				appSelectForm: {}, // 媒体APP下拉选中值
				appRemoteLoading: false,
				platformOptions: [], // 渠道下拉选择列表
				mediaAppMarketOptions: [],// 应用市场下拉列表
				queryData: {
					companyName: ''
				}, // 表格查询条件
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				developerOptions:[
					{value: 1,label:'应用开发者'},
					{value: 2,label:'与应用开发者存在主体关联关系'},
					{value: 3,label:'其他'}
				],
				rulesApi: {
					companyName: [ //公司名称
						{
							required: true,
							message: '必填项，请输入',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 50,
							message: '长度在 1 到 50 个字符',
							trigger: 'blur'
						}
					],
					nickName: [ //公司地址
						{
							required: true,
							message: '请输入公司简称',
							trigger: 'blur'
						},
					],
				},
				mediaRulesApi: {
					name: [{
						required: true,
						message: '请输入APP名称',
						trigger: 'blur'
					}],
					companyId: [{
						required: true,
						message: '请选择公司',
						trigger: 'blur'
					}],
					os: [{required: true,message: '请选择OS',trigger: 'blur'}],
					appMarket: [{required: true,message: '请输入应用市场',trigger: 'blur'}],
					downLink: [{required: true,message: '请输入应用详情页',trigger: 'blur'}],
					sha1: [{required: true,message: '请输入SHA1值',trigger: 'blur'}],
					type: [{required: true,message: '请选择合作模式',trigger: 'blur'}],
					developerType: [{required: true,message: '请选择开发者类型',trigger: 'blur'}],
					packageN: [{
						required: true,
						message: '请输入包名',
						trigger: 'blur'
					}],
					// bundleId:[{required: true,message: '请输入bundleId',trigger: 'blur'}],
					checkType: [{
						required: true,
						message: '请选择审核方式',
						trigger: 'blur'
					}],
				},
				tooltipClose: false,
				mediaFormData: {
					isEarn: 1,
					checkType: 1
				},
				companyFormData: {},

				mediaDrawerShow: false, // 弹框显隐
				channelDialogVisible: false, //
				channelRulesApi: {
					platformId: [{required: true,message: '请选择广告网络',trigger: 'blur'}],
					platformNetworkId: [{required: true,message: '请选择账号名称',trigger: 'blur'}],
					// appName: [{
					// 	required: true,
					// 	message: '请输入应用名称',
					// 	trigger: 'blur'
					// }],
					appKey: [{
						required: true,
						message: '请输入应用ID',
						trigger: 'blur'
					}],
					appSecret:[{
						required: true,
						message: '请输入appSecret',
						trigger: 'blur'
					}]
				},
				channelFormData: {
					status: 1
				},
				channelTableData: [], // 渠道表格数据

				fileList: [],
				fileType: ["pdf", "png", "jpg", "jpeg", "webp"],
				fileListOther: [],
				
				networkOptions: [
					// {label: 'Sigmob',value: 'Sigmob',icon: require('../../assets/adsNetwork/Sigmob.png')}
				],
				networkSelectForm: {}
			}
		},
		computed: {
			isDisable(){
				return !!(this.mediaFormData.checkStatus == 1 || this.mediaFormData.checkStatus == 4);
			},
			// 保留原渠道列表，供上线时手动核对 AppKey 配置
			hasPlatformIdProps() {
				const requiredProps = ['SIGMOB', 'FW','BLK', 'JUTUI', 'CXING','XY','XY_PKG', 'FW_PKG', 'YM', 'KY'];
				return requiredProps.some(prop => this.networkSelectForm.platformId === prop )
			},
			// 根据所选账号在 optionByPlatformId 接口中的 AppKey 支持状态显示输入框
			hasAppKeySupport() {
				return this.accountOptions.some(item => item.id == this.channelFormData.platformNetworkId && item.appKeyStatus == 1)
			},
		},
		activated(){
			this.getCompanyOption();
			// this.getTableData();
		},
		mounted() {
			this.getMediaAppOption();
			// this.getOSOption();
			this.getPlatformOption();
			this.getMediaAppMarketOption();
			this.getNetworkOtions();
		},
		methods: {
			// 复制APP名称
			async copyName(txt){
				try {
					// 使用现代异步 API
					await navigator.clipboard.writeText(txt)
					console.log('复制成功')
					this.$message.success('复制成功');
				} catch (err) {
					console.error('复制失败：', err)
					// 某些环境（比如 HTTP 或非安全上下文）不支持 navigator.clipboard
					// 这里可做回退方案：
					this.fallbackCopy(txt)
				}
			},
			fallbackCopy(text) {
				const input = document.createElement('input')
				input.value = text
				document.body.appendChild(input)
				input.select()
				document.execCommand('copy')
				document.body.removeChild(input)
				this.$message.success('复制成功');
				console.log('已通过旧方式复制')
			},
			// 获取公司下拉列表
			async getCompanyOption() {
				let res = await this.$http.get(this.$api.common.companyOption);
				this.companyOptions = res.data
				if (this.$route.query.name) {
					this.$nextTick(() => {
						this.queryData.companyName = this.$route.query.name
						this.getTableData();
					})
				}else{
					this.getTableData();
				}
			},
			// 获取OS下拉列表
			async getOSOption() {
				let res = await this.$http.get(this.$api.common.osOption);
				this.osOptions = res.data
			},
			companySelectChange(){
				this.mediaAppOptions = []
				this.getMediaAppOption();
			},
			// 获取媒体APP下拉列表
			async getMediaAppOption(query = null) {
				let data = {
					mediaCompany: this.queryData.companyName,
					appId: query,
				}
				let res = await this.$http.get(this.$api.common.mediaAppOption,data);
				this.appRemoteLoading = false
				this.mediaAppOptions = res.data
			},
			// 获取应用市场下拉列表
			async getMediaAppMarketOption() {
				let res = await this.$http.get(this.$api.common.mediaAppMarketOption);
				this.mediaAppMarketOptions = res.data
			},
			// 获取渠道下拉选择列表
			async getPlatformOption() {
				let res = await this.$http.get(this.$api.common.platformOption);
				this.platformOptions = res.data
			},
			// 获取配置后的广告网络下拉选择列表
			async getNetworkOtions(biddingType=null){
				let res = await this.$http.get(this.$api.mediaAd.networkOptionDistinct,{biddingType: biddingType});
				this.networkOptions = res.data
			},
			// 广告位管理
			adSpaceManage(row,index){
				if(row.checkStatus!='2') return
				this.$router.push({
					path: '/aggregation/adSpaceManage',
					query: {
						sideId: 33,
						appId: row.id,
					}
				})
			},


			// 获取table数据
			async getTableData() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize
				}
				data = {
					...data,
					...this.queryData
				}
				if(this.appSelectForm.value){
					data['id'] = this.appSelectForm.value
				}
				let res = await this.$http.post(this.$api.mediaManage.APPList, data);
				this.tableData = []
				this.tableData = res.data.list
				this.total = res.data.totalRecord
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.queryData = {
					companyName: ''
				}
				this.appSelectForm = {}
				this.getTableData();
			},
			confirmQuery() {
				this.currentPage = 1
				this.getTableData();
			},
			
			appSeleteChange(e) {
				this.appSelectForm = e
			},
			appRemoteMethod(query){
				clearTimeout();
				setTimeout(()=>{
					this.appRemoteLoading = true
					this.getMediaAppOption(query)
				},300)
			},
			// 新增媒体信息
			addTableData() {
				this.$router.push({
					path: '/appEdit',
					query: {
						sideId: 32,
						companyName: this.queryData.companyName
					}
				})
				// this.mediaFormData = {
				// 	isEarn: 1
				// }
				// this.fileList = []
				// this.fileListOther = []
				// this.mediaDrawerShow = true
			},
			// 删除媒体信息
			deleteTable(row, index) {
				this.$confirm('此操作将删除该条媒体信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let data = {
						id: row.id
					}
					// if (row === "all") {
					// 	data = this.handleSelection;
					// 	data = data.map(item => {
					// 		return item.id
					// 	})
					// 	this.$refs.multipleTable.clearSelection(); // 清空选项
					// 	console.log(data)
					// } else {
					// 	data.push(row.id)
					// }
					let res = await this.$http.post(this.$api.mediaManage.APPDelete, data);
					if (res.code == 1) {
						this.$message.success('删除成功')
						this.getTableData(); // 刷新
					}
				}).catch();
			},
			// 编辑媒体信息
			editTable(row, index) {
				this.$router.push({
					path: '/appEdit',
					query: {
						sideId: 32,
						id: row.id
					}
				})
				// let allPermissions = this.$store.getters.getPermissions.some(item => item==="*:*:*");
				// if(!this.$store.getters.getPermissions.includes('mediaManage:mediaManage:more')&&!allPermissions){
				// 	return
				// }
				// this.mediaFormData = JSON.parse(JSON.stringify(row))
				// this.fileList = []
				// this.fileListOther = []
				// if(this.mediaFormData.certificationUrl&&this.mediaFormData.certificationUrl.length>0){
				// 	let obj = {}
				// 	for(let i=0;i<this.mediaFormData.certificationUrl.length;i++){
				// 		obj['certificationType'] = 1
				// 		obj['certificationUrl'] = this.mediaFormData.certificationUrl[i]
				// 		obj['name'] = this.mediaFormData.certificationUrl[i]
				// 		this.fileList.push(obj)
				// 		obj = {}
				// 	}
				// }
				// // console.log(this.fileList)
				// if(this.mediaFormData.otherCertificationUrl&&this.mediaFormData.otherCertificationUrl.length>0){
				// 	let obj = {}
				// 	for(let i=0;i<this.mediaFormData.otherCertificationUrl.length;i++){
				// 		obj['certificationType'] = 2
				// 		obj['certificationUrl'] = this.mediaFormData.otherCertificationUrl[i]
				// 		obj['name'] = this.mediaFormData.certificationUrl[i]
				// 		this.fileListOther.push(obj)
				// 		obj = {}
				// 	}
				// }
				// // el-tooltip弹框bug，进行一次开关禁用解决bug
				// this.tooltipClose = true
				// setTimeout(()=>{
				// 	this.tooltipClose = false
				// },200)
				// this.mediaDrawerShow = true
			},
			closeMediaDrawer() {
				this.mediaDrawerShow = false
			},
			// 媒体信息编辑确认
			confirmMedia(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						if(this.fileList.length<=0){
							this.$message.warning('请上传应用资质');
							return
						}
						let data = this.mediaFormData;
						this.mediaFormData['detail'] = this.fileList.concat(this.fileListOther)
						if (data.id) {
							let res = await this.$http.post(this.$api.mediaManage.APPEdit, data);
							if (res.code == 1) {
								this.$message.success('修改成功');
							}
						} else {
							let res = await this.$http.post(this.$api.mediaManage.APPAdd, data);
							if (res.code == 1) {
								this.$message.success('新增成功');
							}
						}
						this.closeMediaDrawer();
						this.getTableData();
					}
				});
			},
			closeDrawer() {
				this.companyDrawerShow = false
				this.mediaFormData = {}
			},
			channelManage(row) {
				this.mediaFormData = JSON.parse(JSON.stringify(row))
				if (row.platAppList && row.platAppList.length > 0) {
					this.channelTableData = row.platAppList
				} else {
					this.channelTableData = []
				}
				this.companyDrawerShow = true
				this.getNetworkOtions(row.biddingType);
			},
			// 关联渠道侧拉框确认
			async confirmChannelDrawer() {
				// let data = this.mediaFormData;
				// if(this.channelTableData.length>0){
				// 	data.platAppList = this.channelTableData
				// }
				// let res = await this.$http.post(this.$api.mediaManage.APPEdit, data);
				// this.$message.success('编辑成功');
				this.closeDrawer();
				// this.getTableData();
			},
			addChannel() {
				this.channelFormData = {
					status: 1,
					platformNetworkId: ''
				}
				this.$set(this, 'networkSelectForm', {})
				this.channelDialogVisible = true
			},
			editChannel(row) {
				this.channelFormData = row
				// console.log(this.channelFormData.platformNetworkId)
				this.networkOptions.forEach((item)=>{
					if(item.platformId == this.channelFormData.platformId){
						this.networkSelectForm = JSON.parse(JSON.stringify(item))
						this.getAccountOptions(item.platformId);
					}
				})
				this.channelDialogVisible = true
			},
			
			networkSeleteChange(e) {
				// console.log(e);
				this.accountOptions = []
				this.channelFormData.platformNetworkId = ''
				if(e){
					this.channelFormData.platformId = e.platformId
					// console.log(this.channelFormData.platformNetworkId);
					this.networkSelectForm = e
					this.getAccountOptions(e.platformId);
				}
				// console.log(this.networkSelectForm)
			},
			async getAccountOptions(platformId){
				let data = {platformId: platformId}
				let res = await this.$http.get(this.$api.mediaAd.networkAccountOption,data);
				this.accountOptions = res.data
				// this.accountOptions.forEach((item)=>{
				// 	if(item.id == this.channelFormData.platformNetworkId){
				// 		this.networkSelectForm = JSON.parse(JSON.stringify(item))
				// 		this.getAccountOptions(item.platformId);
				// 	}
				// })
			},
			// 审核
			review(row, index, type) {
				let msg = '此操作将审核该条媒体信息状态为“通过”, 是否继续?'
				if (type == 3) {
					msg = '此操作将审核该条媒体信息状态为“驳回”, 是否继续?'
				}
				this.$confirm(msg, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					let data = {
						appId: row.id,
						status: type
					}
					let res = await this.$http.get(this.$api.mediaManage.AppAuditStatus, data);
					if (res.code == 1) {
						this.$message.success('审核成功')
						this.getTableData(); // 刷新
					}
				}).catch();
			},
			closeChannelDialog() {
				this.channelDialogVisible = false
			},
			// 渠道新增编辑框确认
			confirmChannel(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let data = this.channelFormData;
						data['appId'] = this.mediaFormData.id
						data['appName'] = this.mediaFormData.name
						// console.log(JSON.stringify(data))
						if (data.id) {
							let res = await this.$http.post(this.$api.mediaManage.platformAppEdit, data);
							if (res.code == 1) {
								this.$message.success('修改成功');
								this.closeDrawer();
								this.closeChannelDialog();
							}
						} else {
							let res = await this.$http.post(this.$api.mediaManage.platformAppAdd, data);
							if (res.code == 1) {
								this.$message.success('新增成功');
								this.closeDrawer();
								this.closeChannelDialog();
							}
						}
						this.getTableData();
					}
				});
			},
			platformChange(val) {
				this.platformOptions.forEach(item => {
					if (item.value == val) {
						this.channelFormData['platformName'] = item.label
					}
				})
			},
			// 媒体APP状态修改
			appSwitchChange(e, row) {
				// console.log(e)
				// if(row.checkStatus == 1||row.checkStatus == 3){
				// 	this.$message.warning('应用审核未通过不可更改启用状态');
				// 	return
				// }
				let msg = '确认启用该应用？'
				if (e == 0) {
					msg = '关闭应用开关将无法拉取广告，确认关闭?'
				}
				this.$confirm(msg, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.changeAppStatus(e,row)
				}).catch(()=>{});
			},
			async changeAppStatus(e,row){
				let data = {
					appId: row.id,
					status: e
				}
				let res = await this.$http.get(this.$api.mediaManage.AppStatus, data);
				if (res.code == 1) {
					this.$message.success('状态修改成功');
					this.getTableData()
				}
			},
			// 渠道状态修改
			async channelSwitchChange(e, row) {
				let data = {
					id: row.id,
					status: e
				}
				let res = await this.$http.get(this.$api.mediaManage.platformAppStatus, data);
				if (res.code == 1) {
					this.$message.success('状态修改成功');
				}else{
					if(row.status == 1){
						row.status = 0
					}
				}
			},
			handleBeforeUpload(file) {
				// 文件类型校验
				let fileExtension = "";
				if (file.name.lastIndexOf(".") > -1) {
					fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
				}
				const isTypeOk = this.fileType.some((type) => {
					// if (file.type.indexOf(type) > -1) return true;
					if (fileExtension && fileExtension.indexOf(type) > -1) return true;
					return false;
				});
				if (!isTypeOk) {
					this.$message.error(`文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`);
					return false;
				}
				return true
			},
			// 上传文件
			async uploadFun(file) {
				console.log(file)
				if(this.fileList.length>=5){
					this.$message.warning(`文件数量最多不超过5个!`);
					return
				}
				const fileExtension = file.name.split(".").pop().toLowerCase(); // 获取文件后缀名
				const isTypeOk = this.fileType.includes(fileExtension);
				if (!isTypeOk) {
					return false; // 阻止文件上传并移除
				}
				// 上传
				let formdata = new FormData();
				formdata.append("file", file.raw);
				let res = await this.$http.post(this.$api.common.uploadFile, formdata);
				if (res.code == 1) {
					let obj = {
						certificationType: 1,
						name: res.data.url,
						certificationUrl: res.data.url
					}
					this.fileList.push(obj)
				}
			},
			//移除文件
			handleRemove(file) {
				let index = -1
				for (let i = 0; i < this.fileList.length; i++) {
					if (file.name == this.fileList[i].certificationUrl) {
						index = i
					}
				}
				if (index >= 0) this.fileList.splice(index, 1)
				console.log(this.fileList)
			},
			uploadSet() {},
			async uploadFunOther(file){
				if(this.fileListOther.length>=5){
					this.$message.warning(`文件数量最多不超过5个!`);
					return
				}
				const fileExtension = file.name.split(".").pop().toLowerCase(); // 获取文件后缀名
				const isTypeOk = this.fileType.includes(fileExtension);
				if (!isTypeOk) {
					return false; // 阻止文件上传并移除
				}
				// 上传
				let formdata = new FormData();
				formdata.append("file", file.raw);
				let res = await this.$http.post(this.$api.common.uploadFile, formdata);
				if (res.code == 1) {
					let obj = {
						certificationType: 2,
						name: res.data.url,
						certificationUrl: res.data.url
					}
					this.fileListOther.push(obj)
				}
			},
			handleRemoveOther(file){
				let index = -1
				for (let i = 0; i < this.fileListOther.length; i++) {
					if (file.name == this.fileListOther[i].certificationUrl) {
						index = i
					}
				}
				if (index >= 0) this.fileListOther.splice(index, 1)
			},
			// 下载文件
			downloadFile(item) {
				let a = document.createElement('a')
				a.href = item.certificationUrl
				a.click();
			},
			async downloadTemp(type){
				let data = {
					type: type
				}
				let res = await this.$http.get(this.$api.mediaManage.download, data);
				if (res.code == 1) {
					let a = document.createElement('a')
					a.href = res.data
					a.click();
				}
			},
			uploadSetOther(){},
			
		},
	}
</script>

<style scoped>
	.mianPage {
		padding: 10px;
	}
	
	.topSearch {
		background: #ffffff;
		padding: 16px;
		padding-bottom: 6px;
	}
	
	.popoverName{
		font-size: 12px;
		text-align: center;
	}

	.el-form {
		flex-wrap: wrap;
	}

	/deep/ .el-form--inline .el-form-item {
		margin-right: 20px !important;
	}
	/deep/ .el-form-item {
		margin-right: 10px !important;
		margin-bottom: 10px;
	}

	.menu-right {
		margin-left: auto;
		margin-top: 4px;
		/* margin-bottom: 20px; */
	}
	
	.tableBox {
		margin-top: 10px;
		background: #ffffff;
		padding: 16px;
	}

	.cardTitle {
		font-weight: 500;
		font-size: 22px;
		color: #000000;
	}

	.cardTitle i {
		cursor: pointer;
	}

	.cardTitleTxt {
		font-size: 16px;
	}

	.box-card {
		height: 100%;
		overflow-y: auto;
	}

	.box-card /deep/ .el-form--inline .el-form-item {
		display: block !important;
	}
	
	/deep/ .el-form-item__content {
		line-height: 32px;
	}

	.box-card /deep/ .el-card__body {
		/* height: 90%; */
		overflow-y: auto !important;
		box-sizing: border-box;
	}

	.card-bottom {
		padding-right: 30px;
	}



	.pageTopBox {
		height: 54px;
		width: 100%;
		/* border-left: 3px solid #4568dc; */
		box-shadow: 0 3px 15px rgb(0 0 0 / 5%);
		padding: 0 20px;
		box-sizing: border-box;
		background: #FFFFFF;
		align-items: center;
	}

	.addBtn {
		padding-right: 5px;
	}

	.titleText {
		font-family: PingFang SC, PingFang SC;
		line-height: 54px;
		font-weight: 500;
		font-size: 18px;
		color: #333333;
	}

	.crumbsText {
		margin-left: auto;
		font-size: 14px;
		line-height: 54px;
		cursor: pointer;
		color: #4568dc;
	}

	.crumbsText span {
		color: #6c757d;
		cursor: auto;
	}

	.drawerTable {
		margin: 20px 0;
		padding: 10px;
		box-sizing: border-box;
	}

	.box-card /deep/ .el-card__body {
		box-sizing: border-box;
	}

	.editBtn {
		align-items: center;
		cursor: pointer;
		color: #4F7AFD;
		margin-right: 10px;
	}

	.editBtnTxt {
		font-weight: 500;
		font-size: 14px;
		margin-left: 2px;
	}

	.auditStatus {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.statusLabel {
		width: 6px;
		height: 6px;
		border-radius: 50%;
		margin-right: 4px;
		background: #FA9600;
	}

	.splitLine {
		width: 95%;
		height: 1px;
		background: #DFDFDF;
		margin: 30px;
	}

	.tipsIcon {
		font-size: 16px;
		margin-top: 2px;
		margin-left: 2px;
	}

	.formDesc {
		font-weight: 500;
		font-size: 12px;
		color: #999999;
		line-height: 18px;
		margin-top: 4px;
	}

	.formDesc span {
		color: #FC474C;
	}


	.uploadBtn {
		width: 108px;
		height: 32px;
		background: #FAFAFA;
		border-radius: 2px;
		border: 1px solid #E0E0E0;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
	}

	.uploadImg {
		width: 16px;
		height: 16px;
		margin-right: 5px;
	}

	.uploadTxt {
		font-weight: 500;
		font-size: 14px;
		color: #333333;
	}

	.el-upload__tip {
		font-weight: 500;
		font-size: 12px;
		color: #AAAAAA;
	}
	
	
	.drawTableRow,
	.drawTableRowTwo {
		background: #F7F8F9;
		height: 47px;
		border-bottom: 1px solid #EAEFF5;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding: 0 16px;
	}
	
	.drawTableRowTwo {
		background: none;
		border: none;
	}
	
	.rowContent {
		font-weight: 600;
		font-size: 14px;
		color: #666666;
		margin-right: 40px;
	}
	
	.fileCont {
		width: 100%;
		height: 28px;
		font-family: PingFang SC, PingFang SC;
		background: #F7F7F7;
		font-weight: 500;
		font-size: 12px;
		color: #333333;
		line-height: 28px;
		padding-left: 4px;
		white-space: nowrap; 
		overflow: hidden; 
		text-overflow: ellipsis; 
		cursor: pointer;
	}
	
	
	.appNames{
		align-items: center;
		color: #333333;
		font-weight: 600;
		cursor: pointer;
	}
	.appNames img{
		margin-left: 4px;
		width: 14px;
		height: 14px;
	}
	.tableBtns{
		align-items: center;
	}
	.splitLineTable{
		width: 1px;
		height: 12px;
		background-color: #DEDEDE;
		margin: 0 12px;
	}
	
	
	
	.selectTemp,
	.checkedTemp {
		align-items: center;
		width: 100%;
		font-weight: 500;
		font-size: 14px;
		color: #333333;
	}
	
	.selectTemp img,
	.checkedTemp img {
		width: 24px;
		height: 24px;
		margin-right: 4px;
	}
	
	.checkedTemp {
		height: 32px;
		/* margin-top: 4px; */
	}
	
	.addBtns {
		font-weight: 600;
		font-size: 14px;
		color: #007FFF;
		margin: 16px 0;
		text-align: center;
		cursor: pointer;
	}
	
	/deep/.appNameIdOptions .el-select-dropdown__item {
		height: 48px !important;
		line-height: 48px !important;
	}
	
	.selectTemp2 {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
	
	.selectAppName,
	.selectAppId {
		font-size: 12px;
		color: #333333;
		line-height: 20px;
	}
	
	.selectAppId {
		color: #999999;
		align-items: center;
	}
	
	.selectAppId img {
		width: 14px;
		height: 14px;
		margin-left: 3px;
	}
	.popoverTitle{
		font-weight: 600;
		margin-bottom: 5px;
	}
</style>
